export class PrefectureDropdownController {
  constructor(controller) {
    this.controller = controller
  }

  // ========================================
  // 都道府県ドロップダウン
  // ========================================

  togglePrefectureDropdown(event) {
    event.stopPropagation()
    this.closeCityDropdown()

    // クリックされた要素から親wrapperを見つける
    const wrapper = event.currentTarget.closest('.company-search-form__wrapper--pc, .company-search-form__wrapper--sp')
    const dropdown = wrapper.querySelector('[data-refosumu--home-index--company-search-form-target="prefectureDropdown"]')

    if (dropdown) {
      if (dropdown.style.display === 'none' || dropdown.style.display === '') {
        dropdown.style.display = 'block'
      } else {
        dropdown.style.display = 'none'
      }
    }
  }

  closePrefectureDropdown() {
    // 両方のwrapperのドロップダウンを閉じる
    this.controller.prefectureDropdownTargets.forEach(dropdown => {
      dropdown.style.display = 'none'
    })
  }

  // ========================================
  // 都道府県選択
  // ========================================

  async selectPrefecture(event) {
    event.preventDefault()
    const button = event.currentTarget
    const prefectureName = button.dataset.prefectureName

    // クリックされたボタンから親wrapperを見つける
    const wrapper = button.closest('.company-search-form__wrapper--pc, .company-search-form__wrapper--sp')

    // 選択状態を更新
    this.controller.selectedPrefecture = prefectureName

    // wrapperスコープ内の要素を更新
    const prefectureText = wrapper.querySelector('[data-refosumu--home-index--company-search-form-target="prefectureText"]')
    const prefectureInput = wrapper.querySelector('[data-refosumu--home-index--company-search-form-target="prefectureInput"]')
    const cityText = wrapper.querySelector('[data-refosumu--home-index--company-search-form-target="cityText"]')
    const cityInput = wrapper.querySelector('[data-refosumu--home-index--company-search-form-target="cityInput"]')
    const cityButtonsContainer = wrapper.querySelector('[data-refosumu--home-index--company-search-form-target="cityButtonsContainer"]')

    if (prefectureText) {
      prefectureText.textContent = prefectureName
    }

    if (prefectureInput) {
      prefectureInput.classList.add('company-search-form__select--selected')
    }

    // ドロップダウンを閉じる
    this.closePrefectureDropdown()

    // 市区町村をリセット
    this.controller.selectedCity = null
    this.controller.selectedCityName = null

    if (cityText) {
      cityText.textContent = '選択してください'
    }

    if (cityInput) {
      cityInput.classList.remove('company-search-form__select--selected')
    }

    // 市区町村リストを即座にクリアしてローディング表示
    if (cityButtonsContainer) {
      cityButtonsContainer.textContent = ''
      const loadingDiv = document.createElement('div')
      loadingDiv.className = 'company-search-form__dropdown-loading'
      loadingDiv.textContent = '読み込み中...'
      cityButtonsContainer.appendChild(loadingDiv)
    }

    // 市区町村を取得（CityDropdownControllerに委譲）
    await this.controller.cityDropdownController.loadCities(prefectureName)
  }

  closeCityDropdown() {
    this.controller.cityDropdownController.closeCityDropdown()
  }
}
